import { render, staticRenderFns } from "./IndexProfile.vue?vue&type=template&id=9b583ec8"
import script from "./IndexProfile.vue?vue&type=script&lang=js"
export * from "./IndexProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports